module.exports = __webpack_public_path__ + "static/img/pic3.268cbd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic3.png
// module id = 5ilL
// module chunks = 1